<mat-dialog-content class="mat-typography">
    <mat-progress-spinner [mode]="'indeterminate'" color="primary"> </mat-progress-spinner>
</mat-dialog-content>
